// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2-za_","dragIcon":"Choice_dragIcon__HccQL","left":"Choice_left__30qCh","input":"Choice_input__37Tm8"};